import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";


export const updateProfileApi = createAsyncThunk(
    "community/updateProfileApi",
    async ({ formData, profileId }, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.put(
          `/auth/${profileId}/`,
          formData
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response ? error.response.data : error.message
        );
      }
    }
  );
 